/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

// The editor creator to use.
import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';

import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock';

import FontSize from '@ckeditor/ckeditor5-font/src/fontsize';
import FontColor from '@ckeditor/ckeditor5-font/src/fontcolor';
import FontBackgroundColor from '@ckeditor/ckeditor5-font/src/fontbackgroundcolor';

import List from '@ckeditor/ckeditor5-list/src/list';
import Link from '@ckeditor/ckeditor5-link/src/link';
import Table from '@ckeditor/ckeditor5-table/src/table';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';

// Following are essential for CodeCogs Equation Editor
import Image from '@ckeditor/ckeditor5-image/src/image';
import InsertImage from '@ckeditor/ckeditor5-image/src/imageinsert';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';

import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import EqnEditor5 from '@codecogs/eqneditor-ckeditor5/src/eqneditor5';

import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';
import CKFinderUploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';

export default class ClassicEditor extends ClassicEditorBase {}

// Plugins to include in the build.
ClassicEditor.builtinPlugins = [
	Essentials,
	Bold,
	Italic,
	Heading,
	Indent, IndentBlock,
	FontSize, FontColor, FontBackgroundColor,
	List,
	Link,
    Table,
	Image,				/* Need by EqnEditor 5 */
	MediaEmbed,			/* Need by EqnEditor 5 */
	EqnEditor5,			/* Core of EqnEditor 5 */

    BlockQuote,
    InsertImage,
    ImageCaption,
    ImageStyle,
    ImageToolbar,
    ImageCaption,
    ImageUpload,

    CKFinder,
	CKFinderUploadAdapter,
];

// Editor configuration.
ClassicEditor.defaultConfig = {
	toolbar: {
		items: [
			'heading', 'fontsize',
			'|',
			'EqnEditor5',	/* Added fx button for EqnEditor 5 */
			'bold', 'italic', 'link', 'bulletedList', 'numberedList',
			'|',
			'indent', 'outdent',
			'|',
            'imageUpload','blockQuote', 'insertTable', 'mediaEmbed',
			'|',
            'undo', 'redo',
		]
	},
	// This value must be kept in sync with the language defined in webpack.config.js.
	language: 'en'
};
